export enum EnumPercentages {
  MINIMUM = 80,
  EIGHTY = 80,
  NINETY = 90,
  NINETY_FIVE = 95,
  HUNDRED = 100,
}
